(ns common.resource.query.adserver-account-configuration
  (:require [common.db.effects.http :refer [jsonify]]
            [common.queries.http :as qhttp]))

(defn adserver-account-configurations-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["adserver-account-configurations" advertiser-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/advertiser-adserver-account-configurations
                                           {:advertiser-id advertiser-id})
                             {:params {:embed (jsonify ["adserveraccount.adserver"])}}))
       :staleTime (* 60 1000)
       :enabled (some? advertiser-id)})
